module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAURJREFUSEvtlzFOAzEURGfuQQFNLgA9pIqE4AB0Keg4BMstEIoEXS5AQ0XSoUicgZXIPQaN5EXBRPkhK7Mp1p3l/X6253v/mAAg6RbAGMCh+wVbDeCJ5B0TtCoIWzd1ZfAngAMAhs8LL+A0cZYGK8GGJGclwZLOALyasRYs6RjARbaIN5IvmxYm6QrAIPtm3mxoI3h1MIeQZAD2bryrvJ2QfI/AznDrnR/7zNkYgB2bg92vHLs1mOSwjeaSmhPowb+zWtI5gBsAi0jTSIb0c7LGDySn4XWKJtx1vAfvzy9zVw2juF7j/dBY0gjAfWNRIt22KBouOJckn/si8UPjFfPn+ttNWcz0K24Evg1ZBq5JHgXJ9Jj8+d+tjyM6MXttrk8Um1+nj/R0+Q9D77XZh9XdPWGSpral1+kpE51Ym/ElgIkt1Rc+K4eC0yEEugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/full.png
// module id = GrKk
// module chunks = 1